import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
`

const IMAGE = styled.img``

const ImageWrap = styled.div``

const FullLoading: React.FunctionComponent = () => {
  return (
    <Wrap>
      <ImageWrap>
        <IMAGE src="/images/mojito-games-loading.gif" width="92px" height="90px" alt="loading-icon" />
      </ImageWrap>
    </Wrap>
  )
}

export default FullLoading
